import React from "react";
import { TimeInfo } from "core/components";
import { prepCommonPageProvider } from "pages/commonPage";
import { Id } from "core/utils";
import { showNav, hideFooter } from "pages/commonPage/Nav";
export var prepRoute = function () { return ({
    match: function (type) {
        return type === "Contest";
    },
    page: prepCommonPageProvider(Id.component.contest, function (_a) {
        var time = _a.time;
        return (React.createElement(TimeInfo, null, time));
    }),
    showNav: showNav,
    hideFooter: hideFooter,
}); };
